import { DialogContent, DialogTitle, Typography, Box, List, ListItem, ListItemText, Divider } from "@mui/material";

export default function VerseHelper() {
    return (
        <>
            <DialogTitle textAlign='center'>Aide et procédures</DialogTitle>
            <DialogContent dividers>
                <Typography variant="h6" gutterBottom>Procédure de versement</Typography>
                <Typography paragraph>Les versements fédéreaux peuvent être effectués soit par chèque à l'ordre de la Fédération Adventiste Martinique, soit par virement bancaire, soit en amenant les fonds au siège de la fédération. Il est important de respecter les consignes suivantes pour assurer une bonne traçabilité des fonds :</Typography>
                <ul>
                    <li><Typography paragraph>Utiliser le RIB du siège fédéral fourni dans l'espace d'administration.</Typography></li>
                    <li><Typography paragraph>Indiquer en référence du virement le nom de votre église et le mois de collecte (ex : "Église XYZ - Collecte Mars 2024").</Typography></li>
                    <li><Typography paragraph>Effectuer le virement dans les 5 jours suivant la collecte.</Typography></li>
                </ul>
                <Typography paragraph></Typography>
                <Typography paragraph>Merci de votre rigueur dans le respect de ces consignes, elles sont essentielles pour une gestion transparente et efficace des fonds au sein de notre fédération.</Typography>
                
                <Box p={3}>
                    <Typography variant="h4" gutterBottom>
                    Tutoriel : Édition d’un bordereau de versement
                    </Typography>


                    <Typography variant="h6" gutterBottom>
                    Étape 1 : Sélection des options de versement
                    </Typography>
                    <List>
                    <ListItem><ListItemText primary="Choisir le type de versement : Siège FEAM (amener les fonds au siège de la fédération), chèque ou virement." /></ListItem>
                    <ListItem><ListItemText primary="Indiquer si vous prenez une petite caisse en cochant l'une des cases 'oui' ou 'non' dans la section 'Prendre une petite caisse'." /></ListItem>
                    <ListItem><ListItemText primary="Choisir les dons à verser en sélectionnant la date correspondante dans la liste déroulante de la section 'Période'." /></ListItem>
                    <ListItem><ListItemText primary="Cliquer sur le bouton Continuer." /></ListItem>
                    </List>
                    <Divider sx={{ my: 2 }} />


                    <Typography variant="h6" gutterBottom>
                    Étape 2 : Récapitulatif des recettes et répartition des paiements
                    </Typography>
                    <List>
                    <ListItem><ListItemText primary="Consulter le récapitulatif des recettes locales, fédérales et globales." /></ListItem>
                    <ListItem><ListItemText primary="Vérifier la répartition des paiements : espèces (billets et pièces), chèques, cartes bancaires et virements." /></ListItem>
                    <ListItem style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                        <Typography>Après cette étape, quatre scénarios différents sont possibles selon vos choix de type de versement et de prise ou non de petite caisse:</Typography>
                        <ul>
                            <li><Typography paragraph><strong>Versement Siège FEAM & Petite caisse:</strong> Alimentation de la petite caisse → versement fédéral → récapitulatif & confirmation (les fonds restants sont attribués au dépôt bancaire).</Typography></li>
                            <li><Typography paragraph><strong>Versement Chèque/Virement & Petite caisse:</strong> Alimentation de la petite caisse → récapitulatif & confirmation (les fonds restants sont attribués au dépôt bancaire).</Typography></li>
                            <li><Typography paragraph><strong>Versement Siège FEAM:</strong> versement fédéral → récapitulatif & confirmation (les fonds restants sont attribués au dépôt bancaire).</Typography></li>
                            <li><Typography paragraph><strong>Versement Chèque/Virement:</strong> récapitulatif & confirmation (tous les fonds sont attribués au dépôt bancaire).</Typography></li>
                        </ul>
                    </ListItem>
                    </List>
                    <Divider sx={{ my: 2 }} />


                    <Typography variant="h6" gutterBottom>
                    Étape 3 : Alimentation de la petite caisse (si choisie)
                    </Typography>
                    <List>
                    <ListItem><ListItemText primary="Sélectionner les billets et pièces souhaités (ex. billet de 50 € × 3, pièce de 2 € × 4), dans la limite des espèces disponibles." /></ListItem>
                    <ListItem><ListItemText primary="Respecter la limite mensuelle de petite caisse : ne pas dépasser un montant total défini, et éviter de dépasser la part locale." /></ListItem>
                    </List>
                    <Divider sx={{ my: 2 }} />


                    <Typography variant="h6" gutterBottom>
                    Étape 4 : Alimentation du versement fédéral (si versement au siège)
                    </Typography>
                    <List>
                    <ListItem><ListItemText primary="Répartir les fonds à amener à la fédération entre espèces et chèques." /></ListItem>
                    <ListItem><ListItemText primary="Par défaut, tout ce qui n’est pas mis dans la petite caisse est ajouté automatiquement ici." /></ListItem>
                    <ListItem><ListItemText primary="Vous pouvez ajuster la répartition : retirer ce qui sera déposé sur le compte bancaire de l’église. Ces montants seront automatiquement ajoutés à la section Versement compte bancaire." /></ListItem>
                    </List>
                    <Divider sx={{ my: 2 }} />


                    <Typography variant="h6" gutterBottom>
                    Étape 5 : Récapitulatif final et confirmation
                    </Typography>
                    <List>
                    <ListItem><ListItemText primary="Vérifier le récapitulatif des recettes (locales, fédérales et globales)." /></ListItem>
                    <ListItem><ListItemText primary="Contrôler la répartition des fonds vers le siège fédéral." /></ListItem>
                    <ListItem><ListItemText primary="Contrôler la répartition de la petite caisse." /></ListItem>
                    <ListItem><ListItemText primary="Contrôler la répartition du dépôt sur le compte bancaire." /></ListItem>
                    <ListItem><ListItemText primary="Lire attentivement et corriger toute anomalie avant de valider." /></ListItem>
                    <ListItem><ListItemText primary="Utiliser le bouton Précédent pour revenir à tout moment à une étape précédente." /></ListItem>
                    <ListItem><ListItemText primary="Cliquer sur Terminer pour confirmer et enregistrer. Une fenêtre de confirmation s’affiche pour valider l’opération." /></ListItem>
                    </List>
                </Box>

                <Typography variant="h6" gutterBottom>Contact et assistance</Typography>
                <Typography paragraph>Pour toute question ou besoin d'assistance concernant le processus de versement, n'hésitez pas à contacter votre gestionnaire, la comptabilité ou le service technique par mail à lpam@feam.org.</Typography>
            </DialogContent>
        </>
    );
}